<template>
    <div>
        <div class="text-right" v-if="backButton">
            <span @click="goBack" class="hover:underline cursor-pointer">{{ backButton.label }}</span>
        </div>
        <panel class="flex flex-row w-full mt-3 overflow-visible" :class="backButton ? 'mt-5' : 'mt-16'">
            <div class="flex w-full items-center" >
                <div class="w-36 h-32 p-4 -mt-12 mb-2 relative rounded-lg bg-tertiary text-white overflow-hidden hidden md:block lg:block xl:block" v-if="showIcon">
                    <slot name="icon"></slot>
                </div>

                <div class="w-full ml-6">
                    <ul class="list-reset inline-flex pt-6 -ml-6">
                        <li v-for="(header, index) in tabHeaders" :key="index" @click="activeIndex = index" class="px-5 text-center"  v-bind:class="{ active: index == activeIndex }">
                            <span v-if="typeof header === 'object'">
                                {{ header.label }} <span v-if="header.badge" class="rounded-full px-3 py-1 text-white text-sm bg-red-dark">{{ header.badge }}</span>
                            </span>
                            <span v-else>
                                {{ header }}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </panel>

        <div class="w-full mt-5">
            <div v-for="(header, index) in tabHeaders" :key="index" v-if="index === activeIndex">
                <slot v-bind:name="'tab'+index"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'tabs',
  props: [
    'tabHeaders',
    'showIcon',
    'backButton'
  ],
  data () {
    return {
      activeIndex: 0
    }
  },
  methods: {
    goBack: function () {
      this.$router.push(this.backButton.url)
    }
  }
}
</script>

<style lang="scss" scoped>
    li {
        cursor: pointer;
        border-right: 2px solid navy;
        font-weight: bold;

        &:not(.active) {
            color: #CCC;
        }

        &:last-of-type{
            border-right: 0px solid transparent;
        }
    }

    .tab-icon {
        width: 100px;
        height: 100px;
        border-radius: 5px;
        position: absolute;
        bottom: 10px;
        left: 10px;
        margin-right: 20px;
    }
</style>
